import Vue from 'vue';
import Vuex from 'vuex';
import {isEmpty, sortBy} from 'lodash-es';

Vue.use(Vuex);

export const store = new Vuex.Store({
    strict: true,
    state: {
        isLoading: false,
        isLogged: false,
        kStrings: null,
        isDesktop: false,
        urls: null,
        groupIdList: null, // 1 or more
        productsCartData: null, // 1 or more
        quantity: 1, // no mutation
        cartNotification: null,
        cartWarning: null,
        mubData: {},
    },
    mutations: {
        isLoading(state, payload) {
            state.isLoading = payload;
        },
        isLogged(state, payload) {
            state.isLogged = payload;
        },
        kStrings(state, payload) {
            state.kStrings = Object.assign({}, state.kStrings, payload);
        },
        isDesktop(state, payload) {
            state.isDesktop = payload;
        },
        urls(state, payload) {
            state.urls = Object.assign({}, state.urls, payload);
        },
        groupIdList(state, payload) {
            state.groupIdList = payload;
        },
        productsCartData(state, payload) {
            state.productsCartData = payload;
        },
        cartNotification(state, payload) {
            state.cartNotification = payload;
            let cartItemCount = document.getElementById('cartItemCount');
            let cartIconDiv = document.getElementById('cartIcon');
            let headerImg = document.getElementById('headerImg');

            if (state.cartNotification && state.cartNotification.success) {
                if (cartItemCount) {
                    cartItemCount.classList.add('anim-mode');
                }
                if (cartIconDiv) {
                    cartIconDiv.classList.add('anim-mode');
                }
               /* if(headerImg) {
                    headerImg.classList.add('anim-mode');
                }*/

                setTimeout(() => {
                    setTimeout(() => {
                        state.cartNotification.animationState = 'shrink';
                    }, 200);
                    setTimeout(() => {
                        state.cartNotification.animationState = 'jump';
                    }, 400);
                    setTimeout(() => {
                        //state.cartNotification.animationState = null;
                        state.cartNotification = null;
                        setTimeout(() => {
                            if (cartItemCount) {
                                cartItemCount.classList.remove('anim-mode');
                            }
                            if (cartIconDiv) {
                                cartIconDiv.classList.remove('anim-mode');
                            }
                            /*if(headerImg) {
                                headerImg.classList.remove('anim-mode');
                            }*/
                        }, 100);
                    }, 2000);
                }, 500);
            } else {
                setTimeout(() => {
                    state.cartNotification = null;
                }, 1875);
            }
        },
        cartWarning(state, payload) {
            state.cartWarning = payload;
        },
        mubData(state, payload) {
            state.mubData = Object.assign({}, state.mubData, payload);
        },
    },
    actions: {
        setLoading(context, payload) {
            context.commit('isLoading', payload);
        }, 
        setLogged(context, payload) {
            context.commit('isLogged', payload);
        },
        setKStrings(context, payload) {
            context.commit('kStrings', payload);
        },
        isDesktop(context, payload) {
            context.commit('isDesktop', payload);
        },
        setUrls(context, payload) {
            context.commit('urls', payload);
        },
        groupIdList(context, payload) {
            context.commit('groupIdList', payload);
        }, 
        setProductData(context, payload) {
            if(!isEmpty(payload)) {
                context.commit('productsCartData', payload);
            }
        },
        setCartNotification(context, payload) {
            context.commit('cartNotification', payload);
        },
        setCartWarning(context, payload) {
            context.commit('cartWarning', payload);
            setTimeout(() => {
                context.commit('cartWarning', null);
            }, 4000);
        },
        setWsData(context, payload) {
            //console.log('multi CART DATA: ', payload);
            if (!isEmpty(payload)) {
                // general data
                context.commit('isLogged', payload.isLogged);
                context.commit('kStrings', payload.kStrings);
                context.commit('isDesktop', payload.isDesktop);
                context.commit('urls', payload.urls);
                context.commit('mubData', payload.mubData);
                context.commit('groupIdList', payload.groupIdList);
                //context.commit('productsCartData', payload.groupIdList);
            }
        }
    },
    getters: {
        isLoading: state => state.isLoading,
        isLogged: state => state.isLogged,
        kStrings: state => state.kStrings,
        isDesktop: state => state.isDesktop,
        urls: state => state.urls,
        groupIdList: state => state.groupIdList,
        productsCartData: state => state.productsCartData,
        cartNotification: state => state.cartNotification,
        cartWarning: state => state.cartWarning,
        mubData: state => state.mubData,
    },
});